import { Grid } from "@mui/material";
import { ActivePosition } from "src/types/products";

import NoTransfer from "./NoTransfer";
import RadioRow from "./RadioRow/RadioRow";
import TotalValue from "./TotalValue";

// ----------------------------------------------------------------------

type Props = {
	position: ActivePosition;
};

export const ValueSelectorRow = ({ position }: Props) => {
	const { positionId, owners, titles, amount, transferTaxExempt, localCurrency } = position;
	const canTransfer = transferTaxExempt || transferTaxExempt === null;
	const tDisabled = owners.length > 1 || !canTransfer;

	return (
		<Grid
			container
			sx={{ mt: { xs: 0.5, sm: 1 } }}
			justifyContent={"space-between"}
			alignItems={"center "}
			rowSpacing={{ xs: 1 }}
		>
			<Grid item>
				<TotalValue shares={titles} value={amount} currency={localCurrency} />
			</Grid>
			<Grid item>
				{!tDisabled ? <RadioRow id={positionId} /> : <NoTransfer isOwners={owners.length > 1} />}
			</Grid>
		</Grid>
	);
};

export default ValueSelectorRow;
